import React from 'react'
import {Lang} from 'yougile-lang'
import {
  TabSwitcherItem,
  TwTabSwitcherContainer
} from '../../right-panel/crm/deal-history/deal-time-input-panel/tab-switcher-item'
import {CrmActivitiesFilters, CrmActivitiesView} from '../common'

interface Props {
  filters: CrmActivitiesFilters
  setFilters: (filters: CrmActivitiesFilters) => void
  activitiesView: CrmActivitiesView
}

export const DealViewFilterSwitcher = ({
  filters,
  setFilters,
  activitiesView
}: Props) => {
  const titleDay = Lang.msg.crm.activitiesView.tabs.day
  const titleFailed = `${Lang.msg.crm.activitiesView.tabs.failed} (${activitiesView.stats?.failed})`
  const titleCompleted = `${Lang.msg.crm.activitiesView.tabs.completed} (${activitiesView.stats?.completed})`

  return (
    <TwTabSwitcherContainer>
      <TabSwitcherItem
        title={titleDay}
        active={filters.page === 'day'}
        onClick={() => {
          setFilters({
            ...filters,
            page: 'day'
          })
        }}
      />
      <TabSwitcherItem
        title={titleFailed}
        active={filters.page === 'failed'}
        onClick={() => {
          setFilters({
            ...filters,
            page: 'failed'
          })
        }}
      />
      <TabSwitcherItem
        title={titleCompleted}
        active={filters.page === 'completed'}
        onClick={() => {
          setFilters({
            ...filters,
            page: 'completed'
          })
        }}
      />
    </TwTabSwitcherContainer>
  )
}
